import React, { useEffect, useState } from "react";
import classNames from "classnames"; // Correct the import here
import AuthUtil from "../../utils/auth";
import LayoutHeader from "../layout-header/layout-header";
import styles from "./layout.module.css";
import LayoutFooter from "../layout-footer/layout-footer";
import SiderBarComponent from "../../components/menu";

interface DashboardComponentProps {
  children: React.ReactNode; // Define the type for children
}

export default function DashboardComponent({
  children,
}: DashboardComponentProps) {
  const [isSidebarToggle, setSidebarToggle] = useState(true);
  const onToggleSideBar = () => {
    setSidebarToggle(!isSidebarToggle);
  };

  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [isMobileView, setIsMobileView] = useState(false);
  // Uncomment and fix the authentication check if needed
  useEffect(() => {
    const checkAuthentication = async () => {
      if (!AuthUtil.isTokenExist()) {
        window.location.href = "/login";
      } else {
        setIsAuthenticated(true);
      }
    };
    checkAuthentication();
  });

  useEffect(() => {
    const checkMobileView = () => {
      const width = window.innerWidth;
      setIsMobileView(width <= 576);

      if (width <= 576) {
        setSidebarToggle(false);
      }
    };

    checkMobileView();
    window.addEventListener("resize", checkMobileView);

    return () => window.removeEventListener("resize", checkMobileView);
  }, []);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className={classNames(styles.dashboardLayout, "dashboard_layout")}>
      {isMobileView && isSidebarToggle && (
        <div className={styles.mobileOverlay} onClick={onToggleSideBar}></div>
      )}
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          className={classNames(
            styles.sidebar,
            { [styles.sidebarExpanded]: isSidebarToggle },
            { [styles.sidebarCollapsed]: !isSidebarToggle },
            { [styles.mobileSidebar]: isMobileView }
          )}
        >
          <SiderBarComponent sideBarStatus={isSidebarToggle} />
        </div>
        <div
          className={classNames(
            styles.content,
            isSidebarToggle ? styles.contentExpanded : styles.contentCollapsed
          )}
        >
          <LayoutHeader
            onToggleSideBar={onToggleSideBar}
            sideBarStatus={isSidebarToggle}
          />
          {children}
          <LayoutFooter />
        </div>
        <div className={classNames(styles.advanceSidebar)}></div>
      </div>
    </div>
  );
}
